import React, { Component } from 'react'
import Modal from 'react-modal'
import Hammer from 'react-hammerjs'
import { ReactComponent as IconClose } from '../../img/icon-close-primary.svg';

export default class extends Component {

  constructor(props) {
    super(props)
    Modal.setAppElement('#root')
  }

  handleSwipe(e) {
    if (e.direction === 16) {
      this.props.hidePopup()
    }
  }

  render() {

    return (
        <Modal
          isOpen={ this.props.open } 
          contentLabel="Modal" 
          className={{
            base: 'bottom-modal',
            afterOpen: 'bottom-modal_after-open',
            beforeClose: 'bottom-modal_before-close'
          }}
          overlayClassName={{
            base: 'bottom-overlay',
            afterOpen: 'bottom-overlay_after-open',
            beforeClose: 'bottom-overlay_before-close'
          }} 
          onRequestClose={ () => { this.props.hidePopup() } } 
          closeTimeoutMS={ 600 }
        >
          <Hammer direction="DIRECTION_VERTICAL" onSwipe={ (e) => { this.handleSwipe(e) } }>
            <div className="swipe-close">
              <button className="btn-close" onClick={ (e) => { this.props.hidePopup() } }><IconClose/></button>
              { this.props.children }
            </div>
          </Hammer>
        </Modal>
    )
  }
}
